import Navigation from '@/components/navigation/Navigation'
import StaticContentUsePolicy from '@/components/statics/StaticContentUsePolicy'
import StaticContentPrivacyPolicy from '@/components/statics/StaticContentPrivacyPolicy'
import StaticContentTerms from '@/components/statics/StaticContentTerms'

export default [
	{
		path: '/static/use-policy',
		name: 'StaticContentUsePolicy',
		components: {
			default: StaticContentUsePolicy,
			menu: Navigation
		},
		props: {
			default: (route) => ({
				cssprop: 'logged-in',
			})
		}
	},
	{
		path: '/static/privacy-policy',
		name: 'StaticContentPrivacyPolicy',
		components: {
			default: StaticContentPrivacyPolicy,
			menu: Navigation
		},
		props: {
			default: (route) => ({
				cssprop: 'logged-in',
			})
		}
	},
	{
		path: '/static/terms',
		name: 'StaticContentTerms',
		components: {
			default: StaticContentTerms,
			menu: Navigation
		},
		props: {
			default: (route) => ({
				cssprop: 'logged-in',
			})
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/statics.js